import { investigationCoverage } from '@/data/capabilities'
import { InvestigationModeBadge } from './InvestigationModeBadge'
import styles from './SocStatusPanel.module.css'

export function SocStatusPanel() {
  return (
    <div className={styles.root}>
      <span className={styles.heading}>Investigation coverage</span>
      <ul className={styles.list}>
        {investigationCoverage.map((item) => {
          const Icon = item.icon
          return (
            <li key={item.id} className={styles.item}>
              <Icon className={styles.icon} aria-hidden="true" />
              <span className={styles.copy}>
                <span className={styles.label}>{item.label}</span>
                <span className={styles.detail}>{item.detail}</span>
              </span>
            </li>
          )
        })}
      </ul>
      <InvestigationModeBadge />
    </div>
  )
}
